import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LanguageProvider } from './context/LanguageContext';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import BackOnTop from './components/BackOnTop/BackOnTop';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';

// Pages
import Home from './pages/Home/Home';
import GettingStarted from './pages/GettingStarted/GettingStarted';
import Faq from './pages/Faq/Faq';
import About from './pages/About/About';
import ContactUs from './pages/ContactUs/ContactUs';
import Courses from './pages/Courses/Courses';
import CourseDetails from './pages/CourseDetails/CourseDetails';
//import StayUpdated from './pages/StayUpdated/StayUpdated';

// CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Komponenta za zaštitu Admin ruta
const ProtectedRoute = ({ isAllowed, children }) => {
  if (!isAllowed) {
    return <Navigate to="/admin-portal-access" replace />;
  }
  return children;
};


const AppContent = ({ isAuthenticated, setIsAuthenticated }) => {
  const location = useLocation();

  const isAdminPage = location.pathname.startsWith('/admin-portal-access') ||
    location.pathname.startsWith('/admin-dashboard');

  return (
    <div className="App">
      {!isAdminPage && <Header />}
      {!isAdminPage && <BackOnTop />}

      <ScrollToTop />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/getting-started" element={<GettingStarted />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course/:id" element={<CourseDetails />} />
        {/* <Route path="/stay-updated" element={<StayUpdated />} /> */}

        {/* Admin Routes */}
        <Route
          path="/admin-portal-access"
          element={<AdminLogin onLogin={setIsAuthenticated} />}
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute isAllowed={isAuthenticated}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isAdminPage && <Footer />}
    </div>
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('adminToken'));

  return (
    <GoogleOAuthProvider clientId="265142476773-stie08n7vgno639feg7ptoe7qjvk4vhj.apps.googleusercontent.com">
      <LanguageProvider>
        <Router>
          <AppContent
            isAuthenticated={isAuthenticated}
            setIsAuthenticated={setIsAuthenticated}
          />
        </Router>
      </LanguageProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
